export const GET_LOAN_LIST_START = 'GET_LOAN_LIST_START';
export const GET_LOAN_LIST_SUCCESS = 'GET_LOAN_LIST_SUCCESS';
export const GET_LOAN_LIST_ERROR = 'GET_LOAN_LIST_ERROR';
export const GET_LOAN_LIST_END = 'GET_LOAN_LIST_END';
